import { http } from 'http';

export default {
  setDriver: data => http.put(`/flex/transport/assignDriver`, data),

  transportAccept: data => http.put(`/flex/transport/accept`, data),

  transportDeny: data => http.put(`/flex/transport/cancel`, data),

  transportReject: data => http.put(`/flex/transport/deny`, data),

  cancelManagement: ({ idTransport }) =>
    http.put(`/flex/transport/cancelManagement`, { idTransport }),

  getIdTransactionOffline: plate =>
    http.put(`/flex/checkinoutOffline/dataFlexCheck/${plate}`, { plate }),

  saveDocumentsOffline: ({ idTransaction, attachmentsDocument }) =>
    http.put('/flex/checkinoutOffline/end', { idTransaction, attachmentsDocument })
};
